import { render, staticRenderFns } from "./BookingsSlotPaymentInProgress.vue?vue&type=template&id=2ebeabf9&"
import script from "./BookingsSlotPaymentInProgress.vue?vue&type=script&lang=js&"
export * from "./BookingsSlotPaymentInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports